import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import DisplayElement from "../DisplayElement";
import {InstallationElement} from "../../../models/operations/InstallationElement";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Operation to display.
     */
    operation: InstallationElement
}

/**
 * Displays the installation-specific attributes of an element.
 * @author Alizée Grand
 * @version 1.1
 * @creation 29/06/2022
 * @last_update 11/07/2022
 **/
class DisplayElementInstallation extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        return (

            <React.Fragment>
                <span><b>{getTranslation("display.operation.element-installation.equipment-id")}</b> : {this.props.operation.equipmentId}</span>
                <br/>
                <span><b>{getTranslation("display.operation.element-installation.title")}</b> :</span>
                <br/>
                <DisplayElement element={this.props.operation.newElement!}/>
                <br/>
            </React.Fragment>

        );

    };

}

export default withTranslation()(DisplayElementInstallation);
